import { jwtDecode } from 'jwt-decode'
import { authKey } from './Constants'

export interface IToken {
  sub: string
  iat: string
  iss: string
  jti: string
  nbf: string
  sut: string
  wid: string
  exp: number
}

export class TokenManager {
  public static validateToken(token: string): boolean {
    if (typeof token !== 'undefined' && token != null && token.length > 0) {
      try {
        const decodedToken = jwtDecode(token) as IToken

        // Validate that the token has not expired
        if (decodedToken.exp < Date.now() / 1000) {
          return false
        }

        return true
      } catch (e) {
        return false
      }
    }

    return false
  }

  public static setToken(token: string): boolean {
    if (this.validateToken(token)) {
      sessionStorage.setItem(authKey, token)
      return true
    }
    return false
  }

  public static clearToken(): void {
    sessionStorage.removeItem(authKey)
  }

  public static getToken(): string {
    return sessionStorage.getItem(authKey) || ''
  }

  public static getDecodedToken(): IToken {
    if (this.getToken() !== null) {
      return jwtDecode(this.getToken())
    }
    return {} as IToken
  }

  public static getTokenHeader() {
    return {
      headers: {
        'X-Access-Token': this.getToken(),
      },
    }
  }
}
